import { Image, StackProps, Text, VStack } from "@chakra-ui/react";

interface Props extends StackProps {
  title?: string;
  subtitle?: string;
}

export const Empty = ({
  title = "Tidak Ditemukan",
  subtitle,
  ...rest
}: Props) => {
  return (
    <VStack className="root-empty" w={"100%"} gap={0} {...rest}>
      <Image
        src="/assets/svg/illustration_empty.svg"
        maxW={["200px", null, "260px"]}
      />

      <Text
        textAlign={"center"}
        textStyle={"h-reg-title"}
        fontWeight={"semibold"}
      >
        {title}
      </Text>

      {subtitle && (
        <Text
          textAlign={"center"}
          textStyle={"h-subtitle"}
          variant={"secondary"}
        >
          {subtitle}
        </Text>
      )}
    </VStack>
  );
};
